import builder from '../builder';
import AlertDiamond from '../../streamline-icons/light/alert-diamond.svg';

export default builder('IconAlertDiamondLight', AlertDiamond);
